import UserHistoryOperations from './UserHistoryOperations'

export default UserHistoryOperations
